/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import "php-unserialize";

export function is_breakpoint_up($breakpoint) {
  let $width = $(window).outerWidth();

  let $breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1280,
    xxl: 1680,
  };

  let $point = $breakpoints[$breakpoint];

  return $width >= $point ? true : false;
}

export function scroll_to($el, $offset, $speed) {
  if (typeof $el === "undefined") {
    return;
  }

  let $scroll;

  if (typeof $el === "number") {
    $scroll = $el;
  } else {
    if (!$el.length) return false;
    if (!$speed) $speed = "slow";

    let $offsetDefault = -1;
    let $header = $("header");
    if ($header.css("position") == "fixed") {
      $offsetDefault = $header.outerHeight() - 1;
    }

    if (typeof $offset === "undefined") $offset = $offsetDefault;

    $scroll = $el.offset().top - $offset;
  }

  $("html,body").animate(
    {
      scrollTop: $scroll,
    },
    $speed,
  );
}

export function translation(key, def) {
  return typeof window.translations !== "undefined" &&
    typeof window.translations[key] !== "undefined"
    ? window.translations[key]
    : def;
}

export function config(key, def) {
  return typeof window.configuration !== "undefined" &&
    typeof window.configuration[key] !== "undefined"
    ? window.configuration[key]
    : def;
}

export function is_visible_in_view($el, $visible = "any", $offset = 0) {
  let docViewTop = $(window).scrollTop();
  let docViewBottom = docViewTop + $(window).height();

  let elemTop = $($el).offset().top;
  let elemBottom = elemTop + $($el).height();

  docViewTop += $offset;

  switch ($visible) {
    case "all":
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
      break;
    case "top-behind":
      return elemTop <= docViewBottom;
      break;
    case "top":
      return elemTop <= docViewBottom && elemTop >= docViewTop;
      break;
    case "bottom":
      return elemBottom <= docViewBottom && elemBottom >= docViewTop;
      break;
    case "any":
      return (
        (elemTop <= docViewBottom && elemTop >= docViewTop) ||
        (elemBottom <= docViewBottom && elemBottom >= docViewTop)
      );
      break;
  }
}

export function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export function raf(func) {
  if (window.requestAnimationFrame !== "undefined") {
    requestAnimationFrame(func);
  } else {
    setTimeout(func, 1000 / 60);
  }
}

export function swiperLazy(name, func) {
  if ((window.lazyLoaded || []).indexOf(name) !== -1) {
    func();
  }

  $(document).bind("swiper.lazy." + name, func);
}

export function decode_yii_cookie(cookie) {
  try {
    let cookieData = PHPUnserialize.unserialize(cookie.substring(64));
    cookie = cookieData[1];

    return cookie;
  } catch (e) {}
}

export function query_decode(query) {
  if (!query) {
    return {};
  }

  let obj = query.split("&").reduce(function (prev, curr, i, arr) {
    let item = curr.split("=");
    let key = decodeURIComponent(item[0]).replace("[]", "");
    let value = decodeURIComponent(item[1]);

    if (value === "") {
      prev[key] = "";
    } else {
      value = trim(value, ",");
      value = value.indexOf(",") !== -1 ? value.split(",") : value;
      if (typeof prev[key] === "undefined") {
        prev[key] = value;
      } else if (typeof prev[key] !== "object") {
        prev[key] = [prev[key]];
        prev[key].push(value);
      } else {
        prev[key].push(value);
      }
    }

    return prev;
  }, {});

  return obj;
}

export function query_encode(obj) {
  let queryParts = [];
  $.each(obj, function (k, v) {
    if (v === "") {
      return true;
    }

    queryParts.push(
      k + "=" + trim(typeof v === "object" ? v.join(",") : v, ","),
    );
  });

  return queryParts.join("&");
}

export function trim(str, charlist) {
  let whitespace = [
    " ",
    "\n",
    "\r",
    "\t",
    "\f",
    "\x0b",
    "\xa0",
    "\u2000",
    "\u2001",
    "\u2002",
    "\u2003",
    "\u2004",
    "\u2005",
    "\u2006",
    "\u2007",
    "\u2008",
    "\u2009",
    "\u200a",
    "\u200b",
    "\u2028",
    "\u2029",
    "\u3000",
  ].join("");
  let l = 0;
  let i = 0;
  str += "";
  if (charlist) {
    whitespace = (charlist + "").replace(/([[\]().?/*{}+$^:])/g, "$1");
  }
  l = str.length;
  for (i = 0; i < l; i++) {
    if (whitespace.indexOf(str.charAt(i)) === -1) {
      str = str.substring(i);
      break;
    }
  }
  l = str.length;
  for (i = l - 1; i >= 0; i--) {
    if (whitespace.indexOf(str.charAt(i)) === -1) {
      str = str.substring(0, i + 1);
      break;
    }
  }
  return whitespace.indexOf(str.charAt(0)) === -1 ? str : "";
}

export function make_url(url) {
  return "/otomotolease" + (url.substring(0, 1) === "/" ? "" : "/") + url;
}
